import React from "react";
import Skeleton from "react-loading-skeleton";
import { useMediaQuery } from "react-responsive";

function UpcommingLoader() {
  const isDastop = useMediaQuery({ query: "(max-width: 1700px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1300px)" });
  const isSmallLaptop = useMediaQuery({ query: "(max-width: 1020px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 880px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 550px)" });
  return (
    <div
      className={`cover white ${
        isTablet ? "" : "horizontal-scroll-bar custom-scrollbar"
      }`}
      style={{
        width: isTablet
          ? "100%"
          : isSmallLaptop
          ? "34%"
          : isLaptop
          ? "29%"
          : isDastop
          ? "23%"
          : "380px",
        position: !isTablet && "fixed",
        right: "0px",
        padding: "15px",
        paddingBottom: !isTablet && "5rem",
        flexGrow: "",
      }}
    >
      <div className="valign-wrapper space-between mb-1 flex-wrap">
        <h6 className="font-cercular-bold margin-0px">
          <Skeleton width={150} />
        </h6>
        <span
          className="small-text grey lighten-3 "
          style={{
            padding: "5px 7px",
            borderRadius: "18px",
            fontWeight: "300",
            marginTop: "5px",
          }}
        >
          <Skeleton width={50} />
        </span>
      </div>
      <div
        className={`${isTablet && "gap-1"}`}
        style={{
          display: "grid",
          gridTemplateColumns: isMobile
            ? "repeat(1,1fr)"
            : isTablet
            ? "repeat(2,1fr)"
            : "",
        }}
      >
        {[...Array(4)]?.map((items, index) => (
          <div
            className={`cover mb-1 flex column p-1 hoverStyle`}
            style={{ gap: "0.8rem" }}
            key={index}
          >
            <div className="valign-wrapper" style={{ gap: "18px" }}>
              <span
                className="circle valign-wrapper justify-center pointer"
                style={{
                  minWidth: "60px",
                  height: "60px",
                  // boxShadow: "1px 5px 6px #969799, 3px 2px 2px #ffffff",
                }}
              >
                <Skeleton width={50} height={50} />
              </span>
              <span>
                <h6
                  className={`font-circular-bold black-text font-14px`}
                  style={{ fontWeight: 700 }}
                >
                  <Skeleton width={150} />
                </h6>
                <p
                  className="font-inter-sans-serif NoOfline"
                  style={{
                    WebkitLineClamp: 2,
                    fontSize: "11px",
                    fontWeight: "500",
                    letterSpacing: "0.2px",
                    color: "#70707080",
                  }}
                >
                  <Skeleton width={200} />
                </p>
              </span>
            </div>
            <p
              className="black-text font-13px border-radius-12 NoOfline"
              style={{
                backgroundColor: "rgba(224, 233, 255, 0.3)",
                padding: "4px 10px",
                width: "96%",
                WebkitLineClamp: 1,
              }}
            >
              <Skeleton width={300} />
            </p>
            <div className="flex" style={{ gap: "24px" }}>
              <span
                className="flex justify-center column border-radius-12 "
                style={{
                  width: "43%",
                  padding: "10px 15px",
                  backgroundColor: "#ACACAC1A",
                }}
              >
                <p className="black-text font-14px font-circular-bold">
                  {" "}
                  <Skeleton width={70} />
                </p>
                <p className="grey-text" style={{ fontSize: "13px" }}>
                  <Skeleton width={120} />
                </p>
              </span>
              <span
                className="flex justify-center column border-radius-12"
                style={{
                  width: "50%",
                  padding: "10px 15px",
                  backgroundColor: "#ACACAC1A",
                }}
              >
                <p className="black-text font-14px font-circular-bold">
                  {" "}
                  <Skeleton width={70} />
                </p>
                <p className="grey-text" style={{ fontSize: "13px" }}>
                  <Skeleton width={120} />
                </p>
              </span>
            </div>
          </div>
        ))}
      </div>
      {isTablet && (
        <div className="flex justify-center mb-1 mt-1">
          <button
            className="bold font-14px white-text cercle-purple border-radius-12"
            style={{ padding: "7px 10px" }}
           
          >
              <Skeleton width={130}/>
          </button>
        </div>
      )}
    </div>
  );
}

export default UpcommingLoader;
